module.exports = __webpack_public_path__ + "img/turbo_on.59c14c9d.svg";